export default "__VITE_ASSET__BfXMNpkn__"